import './Editor.svelte.css';
/* src/Editor.svelte generated by Svelte v3.43.1 */
import {
	SvelteComponent,
	add_flush_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	create_component,
	destroy_block,
	destroy_component,
	detach,
	element,
	empty,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	set_data,
	set_input_value,
	set_style,
	space,
	text,
	transition_in,
	transition_out,
	update_keyed_each
} from "../_snowpack/pkg/svelte/internal.js";

import { calcDiff, getEnhancedEntries } from './utils.js';
import { createEventDispatcher } from '../_snowpack/pkg/svelte.js';
import { Doc } from './diamond-wasm/index.js';
import DocInfo from './DocInfo.svelte.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[15] = list[i];
	return child_ctx;
}

// (58:6) {#if !entry.isDeleted}
function create_if_block(ctx) {
	let span;
	let t_value = /*entry*/ ctx[15].content + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			set_style(span, "background", /*entry*/ ctx[15].color);
			attr(span, "class", "svelte-3ql7g0");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*entries*/ 32 && t_value !== (t_value = /*entry*/ ctx[15].content + "")) set_data(t, t_value);

			if (dirty & /*entries*/ 32) {
				set_style(span, "background", /*entry*/ ctx[15].color);
			}
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (57:4) {#each entries as entry (entry.order)}
function create_each_block(key_1, ctx) {
	let first;
	let if_block_anchor;
	let if_block = !/*entry*/ ctx[15].isDeleted && create_if_block(ctx);

	return {
		key: key_1,
		first: null,
		c() {
			first = empty();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (!/*entry*/ ctx[15].isDeleted) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (detaching) detach(first);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let t0;
	let textarea_1;
	let textarea_1_placeholder_value;
	let t1;
	let docinfo;
	let updating_rleItems;
	let current;
	let mounted;
	let dispose;
	let each_value = /*entries*/ ctx[5];
	const get_key = ctx => /*entry*/ ctx[15].order;

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	function docinfo_rleItems_binding(value) {
		/*docinfo_rleItems_binding*/ ctx[13](value);
	}

	let docinfo_props = {
		doc: /*doc*/ ctx[0],
		entries: /*entries*/ ctx[5]
	};

	if (/*rleItems*/ ctx[3] !== void 0) {
		docinfo_props.rleItems = /*rleItems*/ ctx[3];
	}

	docinfo = new DocInfo({ props: docinfo_props });
	binding_callbacks.push(() => bind(docinfo, 'rleItems', docinfo_rleItems_binding));

	return {
		c() {
			div1 = element("div");
			div0 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t0 = space();
			textarea_1 = element("textarea");
			t1 = space();
			create_component(docinfo.$$.fragment);
			attr(div0, "class", "mirror svelte-3ql7g0");
			attr(textarea_1, "spellcheck", "false");
			attr(textarea_1, "placeholder", textarea_1_placeholder_value = "User " + /*name*/ ctx[1] + " (type here)");
			attr(textarea_1, "class", "svelte-3ql7g0");
			attr(div1, "class", "container svelte-3ql7g0");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div0, null);
			}

			append(div1, t0);
			append(div1, textarea_1);
			/*textarea_1_binding*/ ctx[11](textarea_1);
			set_input_value(textarea_1, /*value*/ ctx[2]);
			insert(target, t1, anchor);
			mount_component(docinfo, target, anchor);
			current = true;

			if (!mounted) {
				dispose = listen(textarea_1, "input", /*textarea_1_input_handler*/ ctx[12]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*entries*/ 32) {
				each_value = /*entries*/ ctx[5];
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div0, destroy_block, create_each_block, null, get_each_context);
			}

			if (!current || dirty & /*name*/ 2 && textarea_1_placeholder_value !== (textarea_1_placeholder_value = "User " + /*name*/ ctx[1] + " (type here)")) {
				attr(textarea_1, "placeholder", textarea_1_placeholder_value);
			}

			if (dirty & /*value*/ 4) {
				set_input_value(textarea_1, /*value*/ ctx[2]);
			}

			const docinfo_changes = {};
			if (dirty & /*doc*/ 1) docinfo_changes.doc = /*doc*/ ctx[0];
			if (dirty & /*entries*/ 32) docinfo_changes.entries = /*entries*/ ctx[5];

			if (!updating_rleItems && dirty & /*rleItems*/ 8) {
				updating_rleItems = true;
				docinfo_changes.rleItems = /*rleItems*/ ctx[3];
				add_flush_callback(() => updating_rleItems = false);
			}

			docinfo.$set(docinfo_changes);
		},
		i(local) {
			if (current) return;
			transition_in(docinfo.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(docinfo.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			/*textarea_1_binding*/ ctx[11](null);
			if (detaching) detach(t1);
			destroy_component(docinfo, detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { name } = $$props;
	let textarea;
	let { doc = new Doc(name) } = $$props;
	let lastValue = '';
	let value = '';

	const refresh = (newDoc = doc) => {
		$$invalidate(0, doc = newDoc);
		let newval = doc.get();

		if (newval != value) {
			$$invalidate(10, lastValue = $$invalidate(2, value = newval));
		}
	};

	const reset = () => {
		$$invalidate(0, doc = new Doc(name));
		$$invalidate(10, lastValue = $$invalidate(2, value = ''));
	};

	const replicateFrom = src => {
		let v = doc.get_vector_clock();
		let changes = src.get_txn_since(v);
		doc.merge_remote_txns(changes);
		refresh();
	};

	const getDoc = () => doc;
	const dispatch = createEventDispatcher();
	let rleItems = true;
	let entries;

	function textarea_1_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			textarea = $$value;
			$$invalidate(4, textarea);
		});
	}

	function textarea_1_input_handler() {
		value = this.value;
		$$invalidate(2, value);
	}

	function docinfo_rleItems_binding(value) {
		rleItems = value;
		$$invalidate(3, rleItems);
	}

	$$self.$$set = $$props => {
		if ('name' in $$props) $$invalidate(1, name = $$props.name);
		if ('doc' in $$props) $$invalidate(0, doc = $$props.doc);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*value, lastValue, doc*/ 1029) {
			$: {
				if (value != lastValue) {
					let vClean = value.replace(/\r\n/g, '\n');
					let diff = calcDiff(lastValue, vClean);
					$$invalidate(10, lastValue = vClean);

					if (diff.del != 0) {
						doc.del(diff.pos, diff.del);
					}

					if (diff.ins != '') {
						doc.ins(diff.pos, diff.ins);
					}

					// console.log(JSON.stringify(diff))
					refresh();
				}
			}
		}

		if ($$self.$$.dirty & /*rleItems*/ 8) {
			$: {
				console.log('rle editor', rleItems);
			}
		}

		if ($$self.$$.dirty & /*value, rleItems, doc*/ 13) {
			$: {
				$$invalidate(5, entries = getEnhancedEntries(value, rleItems, doc));
			} // console.log(JSON.stringify(entries))
		}
	};

	return [
		doc,
		name,
		value,
		rleItems,
		textarea,
		entries,
		refresh,
		reset,
		replicateFrom,
		getDoc,
		lastValue,
		textarea_1_binding,
		textarea_1_input_handler,
		docinfo_rleItems_binding
	];
}

class Editor extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			name: 1,
			doc: 0,
			refresh: 6,
			reset: 7,
			replicateFrom: 8,
			getDoc: 9
		});
	}

	get refresh() {
		return this.$$.ctx[6];
	}

	get reset() {
		return this.$$.ctx[7];
	}

	get replicateFrom() {
		return this.$$.ctx[8];
	}

	get getDoc() {
		return this.$$.ctx[9];
	}
}

export default Editor;